module.exports = "images/doc-city-menu.cba09d5bdf4f4dccfcd2557a23baed93.png";